/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileAnalyticsTermItem } from '../../models/profile-analytics-term-item';

export interface ActivityFollowersTypeHistogram$Params {
  id: number;
  activityId: number;
}

export function activityFollowersTypeHistogram(http: HttpClient, rootUrl: string, params: ActivityFollowersTypeHistogram$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileAnalyticsTermItem>>> {
  const rb = new RequestBuilder(rootUrl, activityFollowersTypeHistogram.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('activityId', params.activityId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProfileAnalyticsTermItem>>;
    })
  );
}

activityFollowersTypeHistogram.PATH = '/analytics/profile/{id}/well-dones/follower-type-histogram/{activityId}';
